import { HOTSPOT_DEBUG_VISIBLE } from '@/config/app'

/** 与控制台问答预览一致的调试色 */
export const HOTSPOT_DEBUG_BG = 'rgba(255, 105, 135, 0.35)'
export const HOTSPOT_DEBUG_BORDER = '1px dashed rgba(255, 82, 122, 0.75)'

export function isHotspotDebugVisible() {
  return HOTSPOT_DEBUG_VISIBLE === true
}

/** 合并到 inline style（问答 overlay 等带背景色的热点） */
export function mergeHotspotDebugStyle(style) {
  if (!isHotspotDebugVisible()) {
    return style || {}
  }
  const base = style && typeof style === 'object' ? { ...style } : {}
  return {
    ...base,
    backgroundColor: HOTSPOT_DEBUG_BG,
    border: HOTSPOT_DEBUG_BORDER,
    boxSizing: 'border-box'
  }
}
